import React from 'react';
import { Alert, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const alertSx = {
  width: '100%',
  borderRadius: 2,
  alignItems: { xs: 'flex-start', sm: 'center' },
  flexDirection: { xs: 'column', sm: 'row' },
  '& .MuiAlert-message': {
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
  '& .MuiAlert-action': {
    ml: { xs: 0, sm: 'auto' },
    pl: { xs: 0, sm: 2 },
    pt: { xs: 1.5, sm: 0 },
    mr: { xs: 0, sm: -0.5 },
    alignSelf: { xs: 'stretch', sm: 'center' },
    width: { xs: '100%', sm: 'auto' },
  },
};

const actionButtonSx = {
  fontWeight: 600,
  whiteSpace: { xs: 'normal', sm: 'nowrap' },
  width: { xs: '100%', sm: 'auto' },
  justifyContent: { xs: 'center', sm: 'flex-start' },
  textAlign: { xs: 'center', sm: 'left' },
};

const StoreCreationBlockedAlert = ({
  billingSetupPath,
  titleKey = 'stores.creationBlockedTitle',
  messageKey = 'stores.creationBlockedMessage',
  actionKey = 'stores.creationBlockedAction',
  sx,
}) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity="warning"
      sx={{ ...alertSx, ...sx }}
      action={billingSetupPath ? (
        <Button
          component={Link}
          to={billingSetupPath}
          color="inherit"
          size="small"
          sx={actionButtonSx}
        >
          {t(actionKey)}
        </Button>
      ) : null}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        {t(titleKey)}
      </Typography>
      <Typography component="span" variant="body2" sx={{ display: 'block' }}>
        {t(messageKey)}
      </Typography>
    </Alert>
  );
};

export default StoreCreationBlockedAlert;
